import { CardType } from '../../constants/payments';

type TMessage = {
  message: string;
};

export type TErrorMessage = TMessage;

export type TSuccessMessage = TMessage;

// eslint-disable-next-line no-shadow
export enum TAlertStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  DEFAULT = 'default',
}

// eslint-disable-next-line no-shadow
export enum TAlertType {
  GENERAL = 'general',
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
  IC_PAYMENT_UPDATE = 'ic_payment_update',
  IC_ADDRESS_UPDATE = 'ic_address_update',
  ABOVE_CHECKBOX = 'above_checkbox',
  CHECKBOX_ERROR = 'checkbox_error',
}

export interface IAlertMessage {
  paymentType?: CardType;
  paymentId?: string;
  paymentInd?: number;
  alertStatus: TAlertStatus;
  alertType?: TAlertType;
  text: React.ReactChild;
  dataTestId?: string;
}

export interface IProAllowanceMessage {
  hideHDCC: boolean;
  content: React.ReactChild;
}
